// src/services/authService.js
import axios from "axios";

const API_URL = `${process.env.REACT_APP_API_BASE_URL}`;

export const login = async (email, password) => {
  const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/authentication/login/creative`, {
    email,
    password,
  });

  return response.data;
};

export const fetchLeads = async () => {
  try {
      const response = await axios.get(`${API_URL}/leads/list`);
      return response.data;
  } catch (error) {
      console.error("Leads verileri çekilirken hata:", error);
      throw new Error("Leads verileri alınamadı.");
  }
};

export const fetchCustomers = async () => {
  try {
      const response = await axios.get(`${API_URL}/customers/list`);
      return response.data;
  } catch (error) {
      console.error("Customers verileri çekilirken hata:", error);
      throw new Error("Customers verileri alınamadı.");
  }
};